import React from 'react';
import { Spinner } from '../Spinner';
import { Button } from '../Button';
import './StateDisplay.scss';

// Loading State Component
export interface LoadingStateProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading...',
  size = 'medium',
  className = '',
}) => {
  return (
    <div className={`state-display state-display--loading ${className}`}>
      <Spinner size={size} />
      {message && <p className="state-display__message">{message}</p>}
    </div>
  );
};

// Error State Component
export interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  message = 'Something went wrong',
  onRetry,
  retryLabel = 'Try Again',
  className = '',
}) => {
  return (
    <div className={`state-display state-display--error ${className}`}>
      <div className="state-display__icon">⚠️</div>
      <p className="state-display__message">{message}</p>
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          {retryLabel}
        </Button>
      )}
    </div>
  );
};

// Empty State Component
export interface EmptyStateProps {
  message?: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  message = 'No data found',
  description,
  icon = '📭',
  action,
  className = '',
}) => {
  return (
    <div className={`state-display state-display--empty ${className}`}>
      <div className="state-display__icon">{icon}</div>
      <p className="state-display__message">{message}</p>
      {description && <p className="state-display__description">{description}</p>}
      {action && <div className="state-display__action">{action}</div>}
    </div>
  );
};

